import axios from "axios";
import store from "@/store";
import { router } from "@/router";
import { useToast } from "vue-toastification";

const API_URL = process.env.VUE_APP_API_URL;
const toast = useToast();

let apiDap = axios.create({
  baseURL: API_URL,
});

apiDap.interceptors.request.use(
  (config) => {
    const user = store.state.auth.user;

    if (user && user.token) {
      config.headers.Authorization = user.token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Agregar un interceptor de respuesta
apiDap.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 403) {
        if (data.message === "Invalid Token") {
          try {
            const loggedIn = store.state.auth.status.loggedIn;

            if (loggedIn) {
              store.dispatch("auth/logout").then(
                () => {
                  toast.warning("Ha finalizado su sesión");
                  router.push("/auth/login");
                },
                (error) => {
                  let errors =
                    (error.response &&
                      error.response.data &&
                      error.response.data.message) ||
                    error.message ||
                    error.toString();
                  toast.error(errors);
                  console.error(errors);
                }
              );
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          console.error("Acceso denegado");
        }
      } else {
        console.error("Error:", status, data);
      }
    } else {
      toast.error("No se ha podido conectar al servidor");
      console.error("Error: Server not respond");
    }

    return error.response;
  }
);

export default apiDap;
